module.exports = {
      id: "icon-audio-twitter-usage",
      viewBox: "0 0 25.209 25.209",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#icon-audio-twitter",
      toString: function () {
        return this.url;
      }
    }